import { useRef, useState } from "react"
import { DetailPage, Row } from "../../components/crud/DetailPage"
import { ListPage } from "../../components/crud/ListPage"
import { DateInput, TextInput } from "../../components/forms/Inputs"
import { postalCodeToCommune } from "../../hooks/helpers"
import { useApi } from "../../hooks/useApi"
import { useTranslations } from "../../layers/Localization"
import { TvaInput } from "./Clients"

function ChantierConcurrentFields({ item, set }) {
    const t = useTranslations()

    const onCodePostalChange = value => {
        set('codePostal')(value)
        set('commune')(postalCodeToCommune(value))
    }

    return <>
        <Row>
            <TextInput label={t("Numéro")} value={item.num} onChange={set('num')} required />
            <TextInput className="grow" label={t("Nom")} value={item.nom} onChange={set('nom')} required />
        </Row>
        <Row>
            <TextInput label={t("Type")} value={item.type} onChange={set('type')} required />
            <TextInput className="grow" label={t("Nom de l'immeuble")} value={item.nomImmeuble} onChange={set('nomImmeuble')} />
        </Row>
        <Row>
            <TextInput className="grow" label={t("Adresse du chantier")} value={item.adresse} onChange={set('adresse')} required />
            <TextInput label={t("Code postal")} value={item.codePostal} onChange={onCodePostalChange} required />
            <TextInput label={t("Commune")} value={item.commune} onChange={set('commune')} required />
        </Row>
        <Row>
            <DateInput label={t("Date de début")} value={item.dateDebut} onChange={set('dateDebut')} required />
            <DateInput label={t("Date de fin")} value={item.dateFin} onChange={set('dateFin')} />
        </Row>
        <Row>
            <TvaInput label={t("Numéro de tva")} value={item.numTva} onChange={set('numTva')} />
            <TextInput className="grow" label={t("Reference courte du client")} value={item.referenceCourteClient} onChange={set('referenceCourteClient')} />
            <TextInput className="grow" label={t("Nom du client")} value={item.nomClient} onChange={set('nomClient')} />
        </Row>
    </>
}

export function ChantiersConcurrentsList(props) {
    const ref = useRef()
    const [reload, setReload] = useState()
    const t = useTranslations()
    const api = useApi()

    const uploadFile = e => {
        const file = e.target.files[0]
        if (file) api.post(`/chantiersConcurrents/upload-non-compete`, { file }).then(reload)
    }
    const mainActions = {
        [t('Importer fichier de non-concurrence')]: reload => {
            setReload(() => reload)
            ref.current.click()
        }
    }

    return <>
        <ListPage model="chantiersConcurrents" title={t("Chantiers non-concurrençables")} columns={{
            [t('Nom')]: 'nom',
            [t("Numéro")]: 'num',
            [t("Client")]: 'nomClient',
            [t('Nom de l\'immeuble')]: 'nomImmeuble',
            [t('Type')]: 'type',
            [t('Date de début')]: 'dateDebut',
            [t('Date de fin')]: 'dateFin',
        }} mainActions={mainActions} {...props} />
        <input ref={ref} type="file" accept=".xlsx" className="hidden" onChange={uploadFile} />
    </>
}

export function ChantierConcurrentDetail(props) {
    const t = useTranslations()
    return <DetailPage model="chantiersConcurrents" title={t("Chantier non-concurrençable")} Fields={ChantierConcurrentFields} {...props} />
}
